import { merge } from 'lodash-es'

const mergeResolvers = resolvers => merge({}, ...resolvers)

export default mergeResolvers
